import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { parseSearch } from '@autopass-web/domain';
import fatMochiJSON from '@autopass-web/domain/json/fat-mochi.json';
import { MochiLottie } from '@autopass-web/mochi-component';

import styles from './index.module.scss';

import { PATH } from '#/guest-aps/config';

export const ZERO_AMOUNT = 'zero-amount';

export const LeavePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const search = parseSearch(location.search);

  useEffect(() => {
    const handleHistory = () => {
      navigate(`${PATH.LEAVE}?${location.search}`, { replace: true });
    };

    window.addEventListener('popstate', handleHistory);
    return () => {
      window.removeEventListener('popstate', handleHistory);
    };
  }, [navigate, location]);

  const { title, desc } = getLeaveMessageFromCode(search?.code);

  return (
    <div className={styles.leave}>
      <div className={styles.lottie}>
        <MochiLottie loop={false} animationData={fatMochiJSON} />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.desc}>{desc}</div>
    </div>
  );
};

function getLeaveMessageFromCode(code: string) {
  switch (code) {
    case ZERO_AMOUNT:
      return {
        title: '緩衝時間免付款',
        desc: '您目前尚在停車緩衝時間內，不會產生交易費用，請盡速離場並期待您下次使用！',
      };
    default:
      return {
        title: '直接取車出場吧！',
        desc: '出場時將即時自動扣款，扣款結果將寄送 Email 通知，請安心。',
      };
  }
}
